import { PartnerService } from "~/services/public/PartnerService"
import type { Item } from "~/models/item/item"

export const state = (): Partner => ({
  partnerIdent: null,
  stores: null,
  storageUnits: null,
  storageUnitItem: null,
})

export const GET_PARTNER_IDENT = 'getPartnerIdent'
export const GET_STORES = "getStores"
export const GET_STORES_AS_OPTIONS = "getStoresAsOptions"
export const GET_STORAGE_UNITS = "getStoreUnits"
export const GET_STORAGE_UNIT_ITEM = "getStoreUnitItem"

export const getters = {
  [GET_PARTNER_IDENT]: (state: Partner): string | null => state.partnerIdent,
  [GET_STORES]: (state: Partner): Record<number, Store>[] | null => state.stores,
  [GET_STORES_AS_OPTIONS]: (state: Partner): ComboboxOption[] => Object.values(state.stores || {})
    .sort((a: Store, b: Store) => a.name.localeCompare(b.name))
    .map((store: Store) => ({
      label: store.name,
      value: store.affiliate_store_id
    })),
  [GET_STORAGE_UNITS]: (state: Partner): Record<number, StorageUnit>[] | null => state.storageUnits,
  [GET_STORAGE_UNIT_ITEM]: (state: Partner): Item | null => state.storageUnitItem,
}

export const _SET_PARTNER_IDENT = 'setPartnerIdent'
export const _SET_STORES = "setStores"
export const _SET_STORAGE_UNITS = "setStorageUnits"
export const _SET_STORAGE_UNIT_ITEM = "setStorageUnitItem"

export const mutations = {
  [_SET_PARTNER_IDENT](state: Partner, partnerIdent: string) {
    state.partnerIdent = partnerIdent
  },
  [_SET_STORES](state: Partner, stores:  Record<number, Store>) {
    state.stores = stores
  },
  [_SET_STORAGE_UNITS](state: Partner, stores:  Record<number, StorageUnit>) {
    state.storageUnits = stores
  },
  [_SET_STORAGE_UNIT_ITEM](state: Partner, storageUnitItem: Item) {
    state.storageUnitItem = storageUnitItem
  }
}

export const SET_PARTNER_IDENT = 'setPartnerIdent'
export const LOAD_STORES = "loadStores"
export const SET_STORES = "setStores"
export const GET_STORE = "getStore"
export const LOAD_STORAGE_UNITS = "loadStorageUnits"
export const SET_STORAGE_UNITS = "setStorageUnits"
export const GET_STORAGE_UNIT = "getStorageUnit"
export const SET_STORAGE_UNIT_ITEM = "setStorageUnitItem"

export const actions = {
  [SET_PARTNER_IDENT]({ commit }, partnerIdent: string) {
    commit(_SET_PARTNER_IDENT, partnerIdent)
  },
  async [LOAD_STORES]({ state, commit }, {$axios, $config, ident, locale}) {
    if (ident) {
      const partnerService = new PartnerService($axios, $config)
      const response = await partnerService.getStores(ident, locale)

      if (response && response.data && response.data.length > 0) {
        const stores = Object.fromEntries(
          response.data.map((store: Store) => [store.affiliate_store_id, store])
        ) as Record<number, Store>
        commit(_SET_STORES, stores)
      }
    }
  },
  [SET_STORES]({ commit }, stores: Record<number, Store>) {
    commit(_SET_STORES, stores)
  },
  [GET_STORE]({ state }, affiliateStoreId: number) {
    return state.stores[affiliateStoreId]
  },
  async [LOAD_STORAGE_UNITS]({ state, commit }, {$axios, $config, ident, locale}) {
    if (ident) {
      const partnerService = new PartnerService($axios, $config)
      const response = await partnerService.getStorageUnits(ident, locale)

      if (response && response.data && response.data.length > 0) {
        const storageUnits = Object.fromEntries(
          response.data.map((storageUnit: StorageUnit) => [storageUnit.affiliate_storage_unit_id, storageUnit])
        ) as Record<number, StorageUnit>
        commit(_SET_STORAGE_UNITS, storageUnits)
      }
    }
  },
  [SET_STORAGE_UNITS]({ commit }, storageUnits: Record<number, StorageUnit>) {
    commit(_SET_STORAGE_UNITS, storageUnits)
  },
  [GET_STORAGE_UNIT]({ state }, affiliateStorageUnitId: number) {
    const storageUnit = state.storageUnits[affiliateStorageUnitId]
    storageUnit.item.quantity = 1
    return storageUnit
  },
  [SET_STORAGE_UNIT_ITEM]({ commit }, storageUnitItem: Item) {
    commit(_SET_STORAGE_UNIT_ITEM, storageUnitItem)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
